import React, { useState, useEffect } from "react";
import "./LandingPage.css";
import { getToken } from "../../services/apiClient";

export default function LandingPage() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const isStaticMode = process.env.REACT_APP_STATIC_MODE === 'true';

    useEffect(() => {
        // Check if user is authenticated by checking for token
        if (!isStaticMode) {
            const token = getToken();
            setIsAuthenticated(!!token);
        }
    }, [isStaticMode]);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };
  return (
    <div className="landing">
      {/* Шапка */}
      <header className="landing-header">
        <a href="/" className="logo">
            <img src="/logo.png" alt="AI-Кликер" />
        </a>

        <nav className="nav">
        <button onClick={() => scrollToSection("for-whom")}>Для кого</button>
        <button onClick={() => scrollToSection("how-it-works")}>Как это работает</button>
        <button onClick={() => scrollToSection("pricing")}>Цены</button>
        <button onClick={() => scrollToSection("faq")}>FAQ</button>
        </nav>

        {!isStaticMode && (
          <div className="auth-buttons">
            {isAuthenticated ? (
              <a href="/profile" className="profile-button">Профиль</a>
            ) : (
              <>
                <a href="/login" className="login">Войти</a>
                <a href="/register" className="register">Регистрация</a>
              </>
            )}
          </div>
        )}
      </header>

    {/* Главный экран */}
      <section className="hero">
        <h1>CLIQUEUR — умный помощник для твоих презентаций</h1>
        <p>
          Просто говори — и искусственный интеллект будет автоматически
          переключать слайды в нужный момент.
        </p>
        {!isStaticMode && (
          <a href="/register" className="cta-button">Попробовать бесплатно</a>
        )}
      </section>

      {/*Ноутбук*/}
        <section className="hero-section">
        <div className="hero-text">
            <h1>
            Говори. Презентуй. Вдохновляй. Остальное — сделает{" "}
            <span className="highlight">CLIQUEUR</span>
            </h1>
        </div>
        <div className="hero-image">
            <img src="/icons/laptop.png" alt="Ноутбук" />
        </div>
        </section>
      
      {/*Для кого*/}
      <section id="for-whom" className="landing-section for-whom">
        <div className="text-block">
          <p className="section-subtitle">Для кого</p>
          <h2 className="section-title">
            Для тех, кто живёт в ритме{" "}
            <span className="highlight">инноваций</span>
          </h2>

          <ul className="features">
            <li>
              <img src="/icons/list.png" alt="✓" />
              Спикеры, преподаватели и эксперты
            </li>
            <li>
              <img src="/icons/list.png" alt="✓" />
              Продакт-менеджеры и стартаперы
            </li>
            <li>
              <img src="/icons/list.png" alt="✓" />
              Те, кто хочет, чтобы их презентации выглядели живыми,
              профессиональными и технологичными
            </li>
          </ul>
        </div>
        <div className="image-block">
            <img src="/icons/tap.png" alt="Для кого" />
        </div>
        </section>

        <section className="landing-section future-features">
        <p>
            В будущем — интеграция с <strong>GigaChat</strong>, чтобы ваша презентация стала <strong>интерактивной</strong>: отвечай на вопросы аудитории, 
            <strong> генерируй</strong> инсайты и <strong>добавляй</strong> новые идеи прямо во время выступления.
        </p>
        </section>


      {/*Как это работает*/}
      <section id="how-it-works" className="landing-section how-it-works">
        <div className="image-block">
          <img src="/icons/star.png" alt="Как это работает" />
        </div>

        <div className="text-block">
          <p className="section-subtitle">Как это работает</p>
          <h2 className="section-title">
            <span className="highlight">Новичок или опытный спикер?</span>
            <br /> Тебе будет актуально.
          </h2>

          <ul className="features">
            <li>
              <img src="/icons/list.png" alt="✓" />
              Распознает ключевые слова и команды в реальном времени.
            </li>
            <li>
              <img src="/icons/list.png" alt="✓" />
              Переключает слайды автоматически — точно в нужный момент.
            </li>
            <li>
              <img src="/icons/list.png" alt="✓" />
              Настраивается под тебя: ключевые слова, команды для переключения
              слайдов.
            </li>
          </ul>
        </div>
      </section>

      {/*Цены*/}
      <section id="pricing" className="landing-section pricing">
        <div className="text-block">
          <p className="section-subtitle">Цены</p>
          <h2 className="section-title">
            Модель оплаты <span className="highlight">Pay as you go</span>
          </h2>
          <p className="pricing-description">
            Первый час трансляции — отличная возможность протестировать все возможности AI Кликера бесплатно!
          </p>
          <div className="pricing-content">
            <table className="pricing-table">
              <thead>
                <tr>
                  <th>Период</th>
                  <th>Стоимость</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Первый час (тестовый период)</td>
                  <td><strong>Бесплатно</strong></td>
                </tr>
                <tr>
                  <td>После тестового периода</td>
                  <td><strong>100 рублей за час трансляции</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/*FAQ*/}
      <section id="faq" className="landing-section faq">
        <div className="text-block">
          <h2 className="section-title">
            <br /> FAQ
          </h2>
          <p>Ответы на частые вопросы появятся здесь совсем скоро...</p>
        </div>
      </section>
    </div>
  );
};